import cssImg from './css3.png';
import htmlImg from './html5.png';
import jsImg from './java-script.png';
import reactImg from './react.png';
import reduxImg from './redux.png';
import tsImg from './typescript.png';
import nodeImg from './nodejs.png';
import mongoImg from './mongodb.png';
import webStudio from './webStudio.png';
import phonebook from './phonebook.png';
import barbershop from './barbershop.png';
import filmApp from './filmApp.png';
import icecream from './icecream.png';
import contactsRestApi from './contactsRestApi.png';
import petly from './petly.png';
import petlyAPI from './petlyAPI.png';
import jsbook from './jsbook.png';

export const images = {
  cssImg,
  htmlImg,
  jsImg,
  reactImg,
  reduxImg,
  tsImg,
  nodeImg,
  mongoImg,
  webStudio,
  phonebook,
  barbershop,
  filmApp,
  icecream,
  contactsRestApi,
  petly,
  petlyAPI,
  jsbook,
};
